import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './SimpleErrorList.css';
import { ListGroup, ListGroupItem } from 'react-bootstrap';

class SimpleErrorList extends Component {
  static propTypes = {
    className: PropTypes.string,
    errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  };

  render() {
    return (
      <div
        className={
          'simple-error-list' +
          (this.props.className !== undefined ? ' ' + this.props.className : '')
        }
      >
        <ListGroup>
          {this.props.errors.map((error, index) => (
            <ListGroupItem bsStyle="danger" key={index}>
              {error}
            </ListGroupItem>
          ))}
        </ListGroup>
      </div>
    );
  }
}

export default SimpleErrorList;



// WEBPACK FOOTER //
// ./src/components/shared/errors/SimpleErrorList.js